import { useGateway } from '@ad-lucy/gateway-provider';
import {
  DefaultActionsErrorView,
  ErrorBoundary,
  LoaderCentered,
} from '@modules/components';
import { getAppConfig } from '@modules/config/appConfig';
import RemoteAssetsLibrary from '@modules/remotes/assetsLibrary';
import { Suspense, useMemo } from 'react';
import type { MfAssetsLibraryAppConfig } from './AssetsLibrary.types';

function AssetsLibrary() {
  const appConfig = getAppConfig();
  const gateway = useGateway();

  const assetsLibraryAppConfig = useMemo<MfAssetsLibraryAppConfig>(
    () => ({
      API_ROOT: appConfig.API_ROOT,
      KEYCLOAK_CLIENT_ID: appConfig.KEYCLOAK_CLIENT_ID,
      KEYCLOAK_REALM: appConfig.KEYCLOAK_REALM,
      KEYCLOAK_URL: appConfig.KEYCLOAK_URL,
      ORG_ID: appConfig.ORG_ID,
      SUPPORTED_LANGUAGES: appConfig.SUPPORTED_LANGUAGES,
      THEME_DEFAULT: appConfig.THEME_DEFAULT,
      THEME_URL: appConfig.THEME_URL,
    }),
    [appConfig],
  );

  return (
    <ErrorBoundary fallback={<DefaultActionsErrorView />}>
      <Suspense fallback={<LoaderCentered />}>
        <RemoteAssetsLibrary
          apiConfig={assetsLibraryAppConfig}
          gateway={gateway}
        />
      </Suspense>
    </ErrorBoundary>
  );
}

export default AssetsLibrary;
